import React from 'react';
import { DynamicIcon, type IconName } from 'lucide-react/dynamic';
import { twMerge } from 'tailwind-merge';

interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  name: IconName;
  color?: string;
  size?: number;
}

const IconButton = ({
  name,
  color = 'black',
  size = 24,
  className,
  ...rest
}: IconButtonProps) => {
  const defaultClasses = 'cursor-pointer hover:opacity-75';
  const disabledClasses = 'disabled:cursor-not-allowed disabled:opacity-50 ';
  const classes = twMerge(defaultClasses, disabledClasses, className);
  return (
    <button className={classes} {...rest}>
      <DynamicIcon name={name} color={color} size={size} />
    </button>
  );
};

export default IconButton;
